export default {"src":"/_next/static/media/404_Leni.32b56e07.svg","height":241,"width":305};